import React from 'react';
import { useController, ApplicationView } from '@aha-app/mvc';
import { type MessageProps } from './MessageContent';
import styles from './ConversationPanel.module.css';
import type AssistantViewController from '../AssistantView/AssistantViewController';
import { FROZEN_CHAT_ERROR } from 'components/Assistant/constants';

const AskMultipleChoiceContent = ({
  body,
  approveAction,
  toolCallId,
}: MessageProps) => {
  const controller = useController<AssistantViewController>();
  const { model } = controller.state;

  const data = JSON.parse(body) as {
    choices: Record<string, any>;
    answer_type: string;
  };

  if (data.answer_type === 'multiple') {
    return (
      <form className={styles.simpleFormMultiple} data-form-id={toolCallId}>
        {data.choices.map((choice: string, index: number) => (
          <React.Fragment key={choice}>
            <label
              htmlFor={`choice-${index}`}
              className={styles.simpleFormChoice}
            >
              <input
                type='checkbox'
                id={`choice-${index}`}
                name='selected_choices[]'
                value={choice}
                disabled={controller.frozenOrNoUsageAvailable()}
                className='tw-mr-2'
              />
              <span>{choice}</span>
            </label>
            {model.isChatFrozen && (
              <aha-tooltip>{FROZEN_CHAT_ERROR}</aha-tooltip>
            )}
          </React.Fragment>
        ))}
      </form>
    );
  } else {
    return (
      <div className={styles.simpleFormSingle}>
        {data.choices.map((choice: string, _index: number) => (
          <React.Fragment key={choice}>
            <button
              type='button'
              className={styles.toolCallButton}
              disabled={controller.frozenOrNoUsageAvailable()}
              onClick={() => approveAction?.({ selected_choice: choice })}
            >
              {choice}
            </button>
            {model.isChatFrozen && (
              <aha-tooltip>{FROZEN_CHAT_ERROR}</aha-tooltip>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  }
};

export default ApplicationView(AskMultipleChoiceContent);
